module.exports = __webpack_public_path__ + "static/media/school-1.0c57676b.jpg";